/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */
import $ from 'jquery';
import { __ } from '@wordpress/i18n';

document.addEventListener('DOMContentLoaded', function () {
  const $inventoryPage = $('.page-template-inventory, .home-featured-inventory');

  function getVehicleChip(label, value) {
    return `<button class="button  btn-outline-brand-gray chip js-${label}" type="button" tabindex="0">
                <span class="button__text">
                    ${label} ${value} 
                </span>
            </button>`;
  }

  function convertBulletsToChips() {
    $('.vehicle').each(function () {
      const $chips = $(this).find('.vehicle__chips');
      const $bullets = $(this).find('.vehicle__bullets .vehicle__bullet-item');

      $bullets.each(function () {
        const textArray = $(this).text().split(':');
        $chips.append(getVehicleChip(textArray[0].trim(), textArray[1].trim()));
      });
      $bullets.remove();
    });
  }

  if ($inventoryPage.length != 0) {
    convertBulletsToChips();
    $(document).on('post_render_inventory_search_results', function () {
      convertBulletsToChips();
    });
  }

  const $vdpPage = $('.vdp-page');

  if ($vdpPage.length != 0) {
    const $priceLabels = $vdpPage.find('.feature-name, .title-text', '.price');

    $priceLabels.each(function() {
      const $priceLabel = $(this).text().trim();
      if ($priceLabel == "Final Dealer Price" ) {
        $(this).text("Dealer Price");
      }
      if ($priceLabel == "Initial Price (MSRP)" ) {
        $(this).text("Selling Price");
      }
    })

  }

  const $showroomTitleText = $('.showroom-page:not(.summary-page) .showroom-title').find(
    '.extend__text, .extend__text-with-icon'
  );

  $showroomTitleText.each(function () {
    $(this).text('');
    $(this).append(
      `<span></span>Build your perfect new Honda from the ground up. Order your customized Honda today through Timmins Honda or browse our available <a class="link link_text showroom-title__text-link" href="/new-inventory">in-stock inventory</a></span>.`
    );
  });
});
